import yamlMapping from '../schema';
import { AssetSchemaRaw } from '../types/asset.types';

/**
 * Loads an asset file based on the provided system type and asset type.
 * @internal
 * @param systemType - The type of the system.
 * @param assetType - The type of the asset.
 * @returns A promise that resolves to the asset schema or undefined if not found.
 */
export const loadAssetFile = async (
	systemType: string,
	assetType: string,
): Promise<AssetSchemaRaw | undefined> => {
	try {
		const file = yamlMapping[systemType]?.[assetType];

		if (!file) {
			return undefined;
		}

		// Copy the asset to make sure no one is modifying it
		return JSON.parse(JSON.stringify(file));
	} catch {
		return undefined;
	}
};
